module.exports = __webpack_public_path__ + "static/media/LoginPage-BG@2x.b3002d42.jpg";